import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useTranslation } from 'react-i18next';
import { getOpenUserAuthUpdateDialog, handleOpenWorkflowDialog, handlePreAlertQuery, showAlertSnackbar } from '../../../reducers/uiSlice';
import { userLogin } from '../../../actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import FullScreenLoading from '../../Common/FullscreenLoading';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: "100%"
        },
        minWidth: 1200,
        zIndex: theme.zIndex.modal + 1
    },
    rowTitle: { 
        fontSize: "1.2rem", 
        backgroundColor: "#303030"
    },
    rowRightBorder: { 
        borderLeft: "1px solid #5F5F5F"
    },
    rowContent: {
        marginTop: 10,
        backgroundColor: "rgba(255, 255, 255, 0.08)"
    },
    selectStyle: {
        marginLeft: 8
    },
    formStyle: {
        display: 'flex',
        flexDirection: 'column'
    }
}));

function UserAuthUpdate(props) {
    const classes = useStyles();
    const {t} = useTranslation('common');
    const dispatch = useDispatch();

    const [values, setValues] = useState({     
        password: '',
        showPassword: false,
        username: ''
    });
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClose = () => {
        window.localStorage.setItem('auth_update_open', 0);
        const event = new Event('storageChange', {detail: window.localStorage.getItem('auth_update_open')});
        window.dispatchEvent(event);
    };
    const handleSubmit = () => {
        setLoading(true);
        dispatch(userLogin(values.username, values.password))
        .then(() => {
            handleClose();
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
        })
        .finally(() => {
            setLoading(false);
        })
    }
    const configChangedHandler = () => {
        setTimeout(() => {
            setOpenModal(window.localStorage.getItem("auth_update_open") !== '0')
        }, 500);
    }

    useEffect(() => {
        window.addEventListener('storageChange', configChangedHandler);
        return () => window.removeEventListener("storageChange", configChangedHandler);
    }, []);

    return (
        <Dialog 
            open={openModal}
            aria-labelledby="form-dialog-title"
            onBackdropClick={false}
        >
            <DialogTitle id="form-dialog-title">{t('update_token')}</DialogTitle>
            <DialogContent className={classes.formStyle}>
                <FormControl className={clsx(classes.margin, classes.textField)}>
                    <InputLabel>{t('username')}</InputLabel>
                    <Input
                        autoComplete='off'
                        type={'text'}
                        value={values.username}
                        onChange={handleChange('username')}
                    />
                </FormControl>
                <FormControl className={clsx(classes.margin, classes.textField)} style={{marginTop: 20}}>
                    <InputLabel htmlFor="standard-adornment-password">{t('password')}</InputLabel>
                    <Input
                        autoComplete='off'
                        type={values.showPassword ? 'text' : 'password'}
                        value={values.password}
                        onChange={handleChange('password')}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                            >
                            {values.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                        }
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={handleSubmit} 
                    color="primary" 
                    disabled={!(values.username&&values.password) || loading}
                >
                    {t('confirm')}
                </Button>
            </DialogActions>
            <FullScreenLoading open={loading}/>
        </Dialog>
    );
}

export default UserAuthUpdate;